// Module
var code = "<div class=\"find-retailer\" ng-click=\"$ctrl.onFindRetailerClick()\"> <i class=\"find-retailer__icon material-icons-outlined\">place</i> <span class=\"find-retailer__label\" ng-bind=\"::$ctrl.label\"></span> <i class=\"find-retailer__icon-arrow material-icons-outlined\">chevron_right</i> </div>";
// Exports
module.exports = code;